import Head from "next/head";
import Link from "next/link";
import { FetchMoreWithLimitFn } from "../../core/paginationFactory";
import { Maybe } from "../../graphql/gpl-graphQLTypes.gen";
import { IProcedure } from "../../typings/filterEntities";
import Button from "../Button/Button";
import Heading from "../Heading/Heading";
import { StarsIcon } from "../Icons/Icons";
import ProcedureCardWide from "../ProcedureCardWide/ProcedureCardWide";
import ShowMore from "../ShowMore/ShowMore";
import StructuredDataProcedure from "../StructuredData/ItemList";
import styles from "./ProcedureResultsGrid.module.css";
interface IProps {
  data: Maybe<IProcedure[]>;
  subTitle: string;
  title: string;
  totalCount: number;
  onFetchMore: FetchMoreWithLimitFn;
}

export default function ProcedureResultsGrid({
  data,
  subTitle,
  title,
  totalCount,
  onFetchMore,
}: IProps) {
  return (
    <section>
      {data && data.length > 0 ? (
        <>
          <StructuredDataProcedure procedures={data} />
          <Heading component="h1" variant="h3">
            {title}
          </Heading>
          <h3 className={styles.subTitle}>
            {subTitle} <span className={styles.count}>• {totalCount} procedures</span>
          </h3>
          <ul className={styles.grid}>
            {data?.map((p) => (
              <li className={styles.gridItem} key={p.uid}>
                <ProcedureCardWide procedure={p} />
              </li>
            ))}
          </ul>
          {onFetchMore ? <ShowMore onClick={onFetchMore} /> : null}
        </>
      ) : (
        <div className={styles.noResultFrame}>
          <Head>
            <meta name="robots" content="noindex, nofollow" />
          </Head>
          <p className={styles.noResultText}>There are no results matching your search.</p>
          <div className={styles.noResultBtnFrame}>
            <Link href="/" className={styles.noResultBtnLink}>
              <Button iconLeft={<StarsIcon />} blurOnClick={true} btnStyle="outline">
                Explore all Procedures
              </Button>
            </Link>
          </div>
        </div>
      )}
    </section>
  );
}
